import { MethodMeta } from './MethodMeta';
import { ServiceMeta } from './ServiceMeta';
export function Event(name) {
  return function (target, targetName, descriptor) {
    var serviceMeta = ServiceMeta.getOrCreate(target);
    var eventMeta = new MethodMeta({
      func: descriptor.value,
      givenName: name,
      name: targetName
    });
    serviceMeta.events.push(eventMeta);
  };
}
//# sourceMappingURL=Event.js.map